import React from 'react';
import classnames from 'classnames';
import { generateColClass, generateReorderClass } from '../utils';
import { Layout } from '../types';

export type ColWidth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type ScreenSizes = boolean | ColWidth;

export interface ColProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  component?: React.ElementType;
  element?: string;
  xs?: ScreenSizes;
  sm?: ScreenSizes;
  lg?: ScreenSizes;
  md?: ScreenSizes;
  first?: Array<Layout['screenSizes']>;
  last?: Array<Layout['screenSizes']>;
}

const Col: React.FunctionComponent<ColProps> = ({
  className,
  children,
  component,
  element = 'div',
  xs,
  sm,
  md,
  lg,
  first,
  last,
  ...otherProps
}) => {
  const Element = component || element;

  const colSizeClasses = generateColClass({ xs, sm, md, lg });
  const reorderClasses = generateReorderClass({
    first,
    last
  });

  return (
    <Element
      className={classnames(colSizeClasses, reorderClasses, className)}
      {...otherProps}
    >
      {children}
    </Element>
  );
};

export default Col;
